// authService.js

const api = {
  url: process.env.REACT_APP_URL_BACKEND,
  //url: "http://192.168.1.16:5001/",
  //url: "http://localhost:5001/",
};

export default api;
